(() => {
  const ELEMENT_NAME = 'product-recommendations';

  function optimizeRecommendationMarkup(recommendations, host) {
    recommendations.querySelectorAll('img').forEach((image) => {
      image.setAttribute('loading', 'lazy');
      image.setAttribute('decoding', 'async');
      image.setAttribute('fetchpriority', 'low');
    });

    if (host.classList.contains('related-products') && host.dataset.optimizeSecondary === 'true') {
      recommendations.querySelectorAll('.media--hover-effect').forEach((media) => {
        const images = media.querySelectorAll(':scope > img');
        images.forEach((image, index) => {
          if (index > 0) image.remove();
        });
      });
    }

    recommendations.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
      const href = link.getAttribute('href') || '';
      if (/quick-order-list|quantity-popover|component-rating/.test(href)) link.remove();
    });
  }

  async function installOptimization(root = document) {
    await customElements.whenDefined(ELEMENT_NAME);

    const RecommendationElement = customElements.get(ELEMENT_NAME);
    if (!RecommendationElement) return;

    const prototype = RecommendationElement.prototype;

    if (!prototype.vareltiPerformanceOptimized) {
      prototype.vareltiPerformanceOptimized = true;

      prototype.initializeRecommendations = function (productId) {
        this.observer?.disconnect();

        const rootMargin =
          this.dataset.rootMargin ||
          (this.classList.contains('complementary-products') ? '0px 0px 160px 0px' : '0px 0px 200px 0px');

        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            this.loadRecommendations(productId);
          },
          { rootMargin }
        );

        this.observer.observe(this);
      };

      prototype.loadRecommendations = function (productId) {
        if (!this.dataset.url || this.dataset.vareltiLoading === 'true') return;

        this.dataset.vareltiLoading = 'true';

        fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
          .then((response) => {
            if (!response.ok) throw new Error(`Recommendation request failed: ${response.status}`);
            return response.text();
          })
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector(ELEMENT_NAME);

            if (recommendations?.innerHTML.trim().length) {
              optimizeRecommendationMarkup(recommendations, this);
              this.innerHTML = recommendations.innerHTML;
            }

            if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
              this.remove();
              return;
            }

            if (this.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            delete this.dataset.vareltiLoading;
          });
      };
    }

    const elements = [];
    if (root.matches?.(ELEMENT_NAME)) elements.push(root);
    root.querySelectorAll?.(ELEMENT_NAME).forEach((element) => elements.push(element));

    elements.forEach((element) => {
      if (!element.dataset.rootMargin) {
        element.dataset.rootMargin = element.classList.contains('complementary-products')
          ? '0px 0px 160px 0px'
          : '0px 0px 200px 0px';
      }

      if (!element.classList.contains('product-recommendations--loaded') && !element.querySelector('.grid__item')) {
        element.initializeRecommendations(element.dataset.productId);
      }
    });
  }

  installOptimization().catch(() => {});

  document.addEventListener('shopify:section:load', (event) => {
    installOptimization(event.target).catch(() => {});
  });
})();
